import React,{Component} from 'react';
import './CreateClients.css';
import MapsNewOrder from '../../../Components/Maps/MapsNewOrder';
import searchbule from '../../../../image/searchbule.svg'

class CreateClients extends Component{
  
    render(){
        return(
            <div className="CreateClient counter">
                <p className="col-md-6 mt-2 p-0 fontsize4 font-weight-bold ">بيانات العميل</p>
                <hr/>
                <form onSubmit={this.props.handleSubmitCreateClient}>
                    <div className="form-group col-lg-6 ">
                        <label htmlFor="Full Name">الاسم</label>

                        <input type="text" className={"form-control badge-pill p-3 " + (this.props.state.nameError ? 'is-invalid' : '')} placeholder="بيانات المتصل" name="name" value={this.props.state.name} onChange={this.props.handleChange} required />
                        <div style={{ fontSize: 12, color: "red" }}>
                            {this.props.state.nameError}
                        </div>
                    </div>
                    <div className="form-group col-lg-6">
                        <label htmlFor="Phone"> رقم الهاتف</label>
                        <div className="relative">
                            <span className="codephone">+20</span>
                        <input type="number" className={"form-control badge-pill pl-5 p-3 " + (this.props.state.phoneError ? 'is-invalid' : '')} placeholder="رقم الهاتف" name="phone" value={this.props.state.phone} onChange={this.props.handleChange} required />
                        </div>
                        <div style={{ fontSize: 12, color: "red" }}>
                            {this.props.state.phoneError}
                        </div>                </div>
                        <MapsNewOrder key={this.props.state.res_done} setStatecoordinatesaddress_alias={this.props.setStatecoordinatesaddress_alias}  state={this.props.state}  />
                    <label >العنوان</label>
                    <div className="col-lg-8 text-center">
                        <div className="form-group  search_div"id="pac-container">
                        <img className="ml-1 img_input" src={searchbule} alt="search"  />
                            <input type="text " id="pac-input" className={"px-5 search_input form-control badge-pill " + (this.props.state.address_nameError ? 'is-invalid' : '')} placeholder="العنوان" name="address_name" value={this.props.state.address_name} onChange={this.props.handleChange} required/>
                            <div style={{ fontSize: 12, color: "red" }} className="text-right">
                            {this.props.state.address_nameError}
                        </div>       
                        </div>
                        
                        <div id="map"></div>
                        <div className="form-group col-12 text-right mt-2">
                        <label >تفاصيل العنوان</label>
                        <input type="text" className={"form-control badge-pill p-3 " + (this.props.state.address_aliasError ? 'is-invalid' : '')} placeholder="تفاصيل العنوان" name="address_alias" value={this.props.state.address_alias} onChange={this.props.handleChange}  required/>
                        <div style={{ fontSize: 12, color: "red" }}>
                            {this.props.state.address_aliasError}
                        </div>                
                    </div>
                    </div>

                    <button type="submit" className="text-white badge-pill p-2 pl-1 px-3 border shadow bluebg text-center m-3"disabled={(this.props.state.inRequest?true:false)}>تسجيل</button>
                </form>
            </div>
        )
    }
}
export default CreateClients;